import {gql} from '@apollo/client'

export const GET_DILIGENCIA_HISTORICO = gql`
  query GetDiligenciaHistorico($filtro: filter, $pagination: Pagination) {
    GetDiligenciaHistorico(filtro: $filtro, pagination: $pagination) {
      result {
        data_criacao
        id
        id_empresa
        id_proprietario
        id_terreno
        id_user
      }
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        totalItems
        totalPages
      }
    }
  }
`

export const GET_DILIGENCIA_HISTORICO_BY_ID = gql`
  query GetDiligenciaHistoricoById($getDiligenciaHistoricoByIdId: Float!) {
    GetDiligenciaHistoricoById(id: $getDiligenciaHistoricoByIdId) {
      data_criacao
      id
      id_empresa
      id_proprietario
      id_terreno
      id_user
    }
  }
`
